import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ExternalReturnValue } from 'src/app/@core/types';
import { LanguageService } from './language.service';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  private languageService = inject(LanguageService);

  public intercept(r: HttpRequest<ExternalReturnValue>,
    next: HttpHandler): Observable<HttpEvent<ExternalReturnValue>> {
    let request: HttpRequest<ExternalReturnValue> = r;
    const language = this.languageService.getLanguage();

    request = request.clone({
      headers: request.headers.set('Accept-Language', `${language}, *`),
    });

    return next.handle(request);
  }
}
